import React, { useEffect, useState } from 'react';

import YetAnotherLightbox from '@qality/common-components/src/lightbox/YetAnotherLightbox';
import { AttachmentFile } from '@qality/common-model';

type Props = {
  files: AttachmentFile[];
  mediaIndex: number;
  isOpen: boolean;
  dialogClose: () => void;
};

export default function AttachmentsDialog({
  files,
  mediaIndex,
  isOpen,
  dialogClose,
}: Props): JSX.Element {
  const [currentMediaIndex, setCurrentMediaIndex] = useState(mediaIndex);
  const [isLightboxOpen, setIsLightboxOpen] = useState(isOpen);

  useEffect(() => {
    setCurrentMediaIndex(mediaIndex);
    setIsLightboxOpen(isOpen);
  }, [mediaIndex, isOpen]);

  const onCancel = (): void => {
    dialogClose();
    setIsLightboxOpen(false);
  };

  return (
    <YetAnotherLightbox
      files={files}
      mediaIndex={currentMediaIndex}
      isOpen={isLightboxOpen}
      dialogClose={onCancel}
    />
  );
}
